/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Module imports.
 */
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ClipboardModule } from 'ngx-clipboard';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { NgbModule, NgbPaginationModule, NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    CarouselModule.forRoot(),
    AccordionModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ClipboardModule,
    FilterPipeModule,
    NgbModule, NgbPaginationModule, NgbAlertModule,
    NgxPageScrollCoreModule

  ],
  exports: [
    FilterPipeModule,
    BsDropdownModule,
    TooltipModule,
    ModalModule,
    CarouselModule,
    AccordionModule,
    BsDatepickerModule,
    ClipboardModule,
    NgbModule,
    NgbPaginationModule,
    NgbAlertModule,
    NgxPageScrollCoreModule
  ]
})
export class AppBootstrapModule { }
